// extracted by mini-css-extract-plugin
var _1 = "Separator_root__70cf5";
export { _1 as "root" }
